// extracted by mini-css-extract-plugin
export default {"info":"Welcome_info__SKdVC","contentContainer":"Welcome_contentContainer__WX+yc","welcomeText":"Welcome_welcomeText__hOxgt"};